import createReactComponent from '../createReactComponent';
export default createReactComponent('config', 'Config', [["path",{"d":"M21 5h-3m-4.25-2v4M13 5H3m4 7H3m7.75-2v4M21 12H11m10 7h-3m-4.25-2v4M13 19H3","key":"svg-0"}]]);